import { getLanguage } from "@home/utils/common";
import { IMetrics, IAdditionalSeries } from "./types";

// 获取指标名称和同期对比的名称
export const getMetricsName = (metric: IMetrics, isEn = true) => {
  const { nameEn, nameCn,
    legendNameEn, legendNameCn,
    toolTipNameEn, toolTipNameCn,
    tableNameEn, tableNameCn,
    compareNameEn, compareNameCn,
    compareLegendNameEn, compareLegendNameCn,
    compareToolTipNameEn, compareToolTipNameCn,
    compareTableNameEn, compareTableNameCn,
    additionalSeries,
  } = metric || {};
  const metricName = getLanguage(isEn, nameEn, nameCn) || "";
  const legendName = getLanguage(isEn, legendNameEn, legendNameCn) || metricName;
  const toolTipName = getLanguage(isEn, toolTipNameEn, toolTipNameCn) || metricName;
  const tableName = getLanguage(isEn, tableNameEn, tableNameCn) || metricName;
  const compareName = getLanguage(isEn, compareNameEn, compareNameCn) || "";
  const compareLegendName = getLanguage(isEn, compareLegendNameEn, compareLegendNameCn) || compareName;
  const compareToolTipName = getLanguage(isEn, compareToolTipNameEn, compareToolTipNameCn) || compareName;
  const compareTableName = getLanguage(isEn, compareTableNameEn, compareTableNameCn) || compareName;
  
  // 处理额外的 series
  const additionalSeriesNames = additionalSeries?.map((series: IAdditionalSeries) => {
    const name = getLanguage(isEn, series.nameEn, series.nameCn) || "";
    const legendName = getLanguage(isEn, series.legendNameEn, series.legendNameCn) || name;
    const toolTipName = getLanguage(isEn, series.toolTipNameEn, series.toolTipNameCn) || name;
    const tableName = getLanguage(isEn, series.tableNameEn, series.tableNameCn) || name;
    return {
      seriesKey: series.seriesKey,
      name,
      legendName,
      toolTipName,
      tableName,
      lineStyle: series.lineStyle,
    };
  }) || [];
  
  return {
    metricName,
    legendName,
    toolTipName,
    tableName,
    compareName,
    compareLegendName,
    compareToolTipName,
    compareTableName,
    additionalSeriesNames,
  };
};